import React, { useEffect, useRef } from 'react'
import QRCode from 'qrcode'
import { BaseView } from '@/components/base'

interface QRCodeCardProps {
  value: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const QRCodeCard: React.FC<QRCodeCardProps> = ({
  value,
  size = 200,
  className = '',
  style,
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    if (!canvasRef.current || !value) return

    QRCode.toCanvas(
      canvasRef.current,
      value,
      {
        width: size,
        margin: 1,
        color: {
          dark: '#000000',
          light: '#FFFFFF',
        },
        errorCorrectionLevel: 'H',
      },
      (error) => {
        if (error) console.error('QR Code generation error:', error)
      },
    )
  }, [value, size])

  return (
    <BaseView
      center
      className={`bg-[#242426] rounded-[42px] p-8 shadow-lg ${className}`}
      style={{
        minWidth: size + 64,
        minHeight: size + 64,
        ...style,
      }}
    >
      <BaseView
        center
        justify="center"
        className="bg-white rounded-lg overflow-hidden"
        style={{
          width: size,
          height: size,
          padding: 10,
        }}
      >
        <canvas
          ref={canvasRef}
          style={{
            width: size - 20,
            height: size - 20,
          }}
        />
      </BaseView>
    </BaseView>
  )
}
